(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["reveal-engine"] && !Shopify.designMode) return;
  try {
    (function () {
    var REVEALED = 'is-revealed';

    // Maps an effect name + distance (px) to the transform start vars.
    function effectVars(effect, distance) {
      var d = distance + 'px';
      switch (effect) {
        case 'fade':
          return { x: '0', y: '0', scale: '1' };
        case 'slide-down':
          return { x: '0', y: '-' + d, scale: '1' };
        case 'slide-left':
          return { x: d, y: '0', scale: '1' };
        case 'slide-right':
          return { x: '-' + d, y: '0', scale: '1' };
        case 'zoom-in':
          return { x: '0', y: '0', scale: '0.92' };
        case 'zoom-out':
          return { x: '0', y: '0', scale: '1.08' };
        case 'slide-up':
        default:
          return { x: '0', y: d, scale: '1' };
      }
    }

    // Writes the per-element CSS custom properties from its data-attributes.
    // Uses setProperty so existing inline styles are preserved.
    function configure(el) {
      var effect = el.getAttribute('data-reveal-effect') || 'slide-up';
      var distance = parseFloat(el.getAttribute('data-reveal-distance'));
      if (isNaN(distance)) distance = 16;
      var duration = parseFloat(el.getAttribute('data-reveal-duration'));
      if (isNaN(duration)) duration = 700;
      var delay = parseFloat(el.getAttribute('data-reveal-delay'));
      if (isNaN(delay)) delay = 0;
      var easing = el.getAttribute('data-reveal-easing');

      var v = effectVars(effect, distance);
      el.style.setProperty('--reveal-x', v.x);
      el.style.setProperty('--reveal-y', v.y);
      el.style.setProperty('--reveal-scale', v.scale);
      el.style.setProperty('--reveal-duration', duration + 'ms');
      el.style.setProperty('--reveal-delay', delay + 'ms');
      if (easing) el.style.setProperty('--reveal-easing', easing);

      // Remember the element's own base delay so stagger can add to it.
      el.__revealBaseDelay = delay;
    }

    function reveal(el) {
      el.classList.add(REVEALED);
    }

    function isOnce(el) {
      return el.getAttribute('data-reveal-once') !== 'false';
    }

    function init() {
      if (
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) {
        // CSS already keeps everything visible; nothing to animate.
        return;
      }

      var items = Array.prototype.slice.call(
        document.querySelectorAll('[data-reveal]')
      );
      items.forEach(configure);

      if (!('IntersectionObserver' in window)) {
        items.forEach(reveal);
        return;
      }

      // Solo elements: revealed individually. Group children are handled by
      // their container, so exclude anything inside a [data-reveal-group].
      var solo = items.filter(function (el) {
        return !el.parentElement || !el.closest('[data-reveal-group]');
      });

      // Observers are keyed by threshold so per-element thresholds work.
      var observers = {};
      function observerFor(threshold) {
        if (observers[threshold]) return observers[threshold];
        var io = new IntersectionObserver(
          function (entries, obs) {
            entries.forEach(function (entry) {
              var el = entry.target;
              if (entry.isIntersecting) {
                reveal(el);
                if (isOnce(el)) obs.unobserve(el);
              } else if (!isOnce(el)) {
                el.classList.remove(REVEALED);
              }
            });
          },
          { threshold: threshold, rootMargin: '0px 0px -8% 0px' }
        );
        observers[threshold] = io;
        return io;
      }

      solo.forEach(function (el) {
        var t = parseFloat(el.getAttribute('data-reveal-threshold'));
        if (isNaN(t)) t = 0.15;
        observerFor(t).observe(el);
      });

      // Group containers: cascade their [data-reveal] children on entry.
      var groups = Array.prototype.slice.call(
        document.querySelectorAll('[data-reveal-group]')
      );
      groups.forEach(function (group) {
        var stagger = parseFloat(group.getAttribute('data-reveal-stagger'));
        if (isNaN(stagger)) stagger = 80;
        var children = Array.prototype.slice.call(
          group.querySelectorAll('[data-reveal]')
        ).filter(function (child) {
          // Only direct members of this group (not a nested group's children).
          return child.closest('[data-reveal-group]') === group;
        });

        var groupIO = new IntersectionObserver(
          function (entries, obs) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              children.forEach(function (child, i) {
                var base = child.__revealBaseDelay || 0;
                child.style.setProperty(
                  '--reveal-delay',
                  base + i * stagger + 'ms'
                );
                reveal(child);
              });
              obs.unobserve(entry.target);
            });
          },
          { threshold: 0.1, rootMargin: '0px 0px -8% 0px' }
        );
        groupIO.observe(group);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
